import { render, staticRenderFns } from "./SearchCatalog.vue?vue&type=template&id=649cd938&lang=pug&"
import script from "./SearchCatalog.vue?vue&type=script&lang=js&"
export * from "./SearchCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports